<script>
  import TitleIcon from './TitleIcon.svelte';

  export let title = '&nbsp;';
  export let introduction = '';
  export let icon_type = '';
  export let flip_order = false;
</script>

<section class="intro">
  {#if icon_type}<TitleIcon {icon_type} />{/if}
  {#if !flip_order}<h1>{@html title}</h1>{/if}
  {#if introduction}<p>{@html introduction}</p>{/if}
  {#if flip_order}<h1 class:flip={flip_order}>{title}</h1>{/if}
</section>

<style>
  .intro {
    position: relative;
    margin: 0 auto 0;
    padding-bottom: 8px;
    max-width: 950px;
    text-align: center;
  }

  h1 {
    margin-bottom: 32px;
    color: #000;
    font-size: 30px;
    font-weight: 700;
  }

  h1.flip {
    margin: 48px 0;
  }

  p {
    margin: 0 auto 8px;
    color: inherit;
    font-size: 18px;
    max-width: 700px;
  }

  p :global(a) {
    color: #fa4616;
  }

  @media (min-width: 992px) {
    h1 {
      font-size: 40px;
    }
  }
</style>
